/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function ContentSearchViewController(
    this: JS5Object,
    $location: JS5Object,
    uiGridConstants: JS5Object,
    ContentSearchService: JS5Object,
    ModalService: JS5Object,
    NavbarUtilService: JS5Object,
    PaginationService: JS5Object,
    SearchFilterService: JS5Object,
    UtilsService: JS5Object
) {



    const getData = () => {
        this.showHidden = $location.search().showHidden;
        const criteria = {
            fetchOffset: this.pagingOptions.pageSize * (this.pagingOptions.currentPage - 1),
            fetchLimit: this.pagingOptions.pageSize,
            includeHidden: this.showHidden,
            searchString: $location.search().searchText,
            type: this.contentType
        };
        this.loadingIndicator.show = true;
        ContentSearchService.getSearchViewData(criteria).then(() => {
            this.gridOptions.columnDefs = _.get(ContentSearchService, `${this.contentType}ColumnDefs`, []);
            this.gridOptions.data = PaginationService.pageData;
            this.loadingIndicator.show = false;
        });
    };

    const paginationPreviousPageHandler = () => {
        --this.pagingOptions.currentPage;
        getData();
    };

    const paginationNextPageHandler = () => {
        ++this.pagingOptions.currentPage;
        getData();
    };

    const paginationPageSizeChanged = () => {
        this.pagingOptions.currentPage = 1;
        getData();
    };

    const navigateToEditView = (content: JS5Object) => {
        const contentPathKeyword = UtilsService.getPathKeywordFromContentType(this.contentType);
        if (_.isNil(content)) {
            $location.url(`meta/${contentPathKeyword}/edit/${_.get(_.first(this.gridApi.selection.getSelectedRows()), 'id')}/properties`);
        } else {
            $location.url(`meta/${contentPathKeyword}/edit/${_.get(content, 'id')}/properties`);
        }
    };

    const navigateToEditViewToCreateContent = () => {
        $location.url(`meta/${UtilsService.getPathKeywordFromContentType(this.contentType)}/edit/-1/properties`);
    };
    const toggleContentHiddenUnhidden = (message: string) => {
        ModalService.showMessageModal({
            messageText: message,
            pullCancelLeft: true,
            title: 'Hide Content',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, () => {
            this.loadingIndicator.show = true;
            const contentId = _.get(_.first(this.gridApi.selection.getSelectedRows()), 'id');
            ContentSearchService.toggleContentHidden(contentId).then(() => {
                getData();
                this.editorForm.$setDirty();
            }).finally(() => {
                this.loadingIndicator.show = false;
            })
        });
    };


    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: [],
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };

    this.onRowDblClick = (row: JS5Object) => {
        if (!row.entity.hidden) {
            navigateToEditView(row.entity);
        }
    };

    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: () => true,
            onClick: navigateToEditViewToCreateContent
        },
        {
            label: 'Edit',
            enabled: () => {
                const selectedRow = _.first(this.gridApi.selection.getSelectedRows());
                return selectedRow && !_.get(selectedRow, 'hidden');
            },
            onClick: navigateToEditView
        },
        {
            label: 'Hide',
            enabled: () => {
                const selectedRow = _.first(this.gridApi.selection.getSelectedRows());
                return selectedRow && !_.get(selectedRow, 'hidden');
            },
            onClick: () => toggleContentHiddenUnhidden('Are you sure that you want to hide this content?')
        },
        {
            label: 'Unhide',
            enabled: () => {
                const selectedRow = _.first(this.gridApi.selection.getSelectedRows());
                return selectedRow && _.get(selectedRow, 'hidden');
            },
            onClick: () => toggleContentHiddenUnhidden('Are you sure that you want to unhide this content?')
        }
    ];

    this.paginationDefs = {
        paginationPrevPageHandler: paginationPreviousPageHandler,
        paginationNextPageHandler: paginationNextPageHandler,
        paginationPageSizeChanged: paginationPageSizeChanged,
        paginationJumpToPageHandler: getData,
        pagingOptions: PaginationService,
    };

    this.toolbarCheckboxDefs = [
        {
            label: 'Show Hidden',
            onUpdate: (newState: boolean) => {
                this.showHidden = newState;
                $location.search('showHidden', newState);
                getData();
            },
            isChecked: this.showHidden
        }
    ];

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        this.showHidden = $location.search().showHidden;
        this.toolbarCheckboxDefs[0].isChecked = this.showHidden;
        PaginationService.resetToDefaultValues();
        this.pagingOptions = PaginationService;
        NavbarUtilService.viewSearchFunction = getData;
        SearchFilterService.populateCriteriaFromLocationSearch();

        getData();
    };
}

angular.module('prism-ui.content').component('contentSearchView', {
    templateUrl: 'meta/content/searchView/content-searchview-template.html',
    controller: ContentSearchViewController,
    bindings: {
        contentType: '<'
    }
});
